import React from 'react';

const REGIME_META = {
    TRENDING_UP:     { label: 'Trending ↑',  cls: 'bg-success' },
    RANGING:         { label: 'Ranging',      cls: 'bg-info text-dark' },
    HIGH_VOLATILITY: { label: 'High Vol.',    cls: 'bg-warning text-dark' },
    TRENDING_DOWN:   { label: 'Trending ↓',  cls: 'bg-danger' }
};

function winRateBadge(wr) {
    if (wr === null || wr === undefined) return <span className='text-muted'>—</span>;
    const cls = wr >= 55 ? 'bg-success' : wr >= 40 ? 'bg-warning text-dark' : 'bg-danger';
    return <span className={`badge py-1 ${cls}`}>{wr.toFixed(1)}%</span>;
}

function netCell(net) {
    const cls = net > 0 ? 'text-success fw-bold' : net < 0 ? 'text-danger fw-bold' : 'text-muted';
    return <span className={cls}>{net > 0 ? '+' : ''}{net.toFixed(2)}</span>;
}

/**
 * props:
 * - data: [{ regime, orders, trades, winRate, net }]
 */
function RegimeStats({ data }) {
    if (!data || !data.length) return null;

    return (
        <div className='card card-body border-0 shadow mb-4'>
            <h6 className='mb-3'>Performance by Market Regime</h6>
            <div className='table-responsive'>
                <table className='table table-hover table-sm mb-0'>
                    <thead>
                        <tr className="align-middle">
                            <th>Regime</th>
                            <th className='text-center'>Orders</th>
                            <th className='text-center'>Paired Trades</th>
                            <th className='text-center'>Win Rate</th>
                            <th className='text-end'>Net P&amp;L</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(row => {
                            const meta = REGIME_META[row.regime] || { label: row.regime, cls: 'bg-secondary' };
                            return (
                                <tr key={row.regime}>
                                    <td>
                                        <span className={`badge py-1 ${meta.cls}`}>{meta.label}</span>
                                    </td>
                                    <td className='text-center'>{row.orders}</td>
                                    <td className='text-center'>{row.trades || '—'}</td>
                                    <td className='text-center'>{winRateBadge(row.winRate)}</td>
                                    <td className='text-end'>{netCell(row.net)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default RegimeStats;
